module.exports = __webpack_public_path__ + "img/brandImg5.09055efd.jpg";